(() => {
  const initColorSwatchDetail = () => {
    if (!location.pathname.startsWith('/products/')) return;
    if (!document.querySelector('[data-color-swatch-detail-style]')) {
      const style = document.createElement('style');
      style.dataset.colorSwatchDetailStyle = '';
      style.textContent = `.color-options .swatch{position:relative;overflow:hidden;isolation:isolate}.color-options .swatch [data-variant-swatch]{width:100%;height:100%;object-fit:contain;transform:scale(1);transition:transform .2s ease;will-change:transform}.color-options .swatch:hover [data-variant-swatch],.color-options .swatch:focus-visible [data-variant-swatch],.color-options .swatch[aria-pressed="true"] [data-variant-swatch]{transform:scale(3.4)}@media(hover:none){.color-options .swatch:not([aria-pressed="true"]):hover [data-variant-swatch]{transform:scale(1)}}@media(prefers-reduced-motion:reduce){.color-options .swatch [data-variant-swatch]{transition:none}}`;
      document.head.appendChild(style);
    }
    const group = document.querySelector('.tfp-benchmark .color-options');
    if (!group || group.dataset.colorNamePreviewReady === 'true') return;
    group.dataset.colorNamePreviewReady = 'true';
    const name = group.querySelector('[data-option-name]');
    if (!name) return;
    const restore = () => {
      const selected = group.querySelector('.swatch[aria-pressed="true"]');
      if (selected?.dataset.value) name.textContent = selected.dataset.value;
    };
    group.querySelectorAll('.swatch').forEach((button) => {
      const show = () => { if (button.dataset.value) name.textContent = button.dataset.value; };
      button.addEventListener('mouseenter', show);
      button.addEventListener('focus', show);
      button.addEventListener('mouseleave', restore);
      button.addEventListener('blur', restore);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initColorSwatchDetail);
  else initColorSwatchDetail();
  document.addEventListener('shopify:section:load', initColorSwatchDetail);

  const parseJSON = (node) => {
    try { return JSON.parse(node?.textContent || '[]'); }
    catch (_) { return []; }
  };

  const imageURL = (variant) => {
    if (!variant) return '';
    if (variant.featured_media?.preview_image?.src) return variant.featured_media.preview_image.src;
    if (variant.featured_image?.src) return variant.featured_image.src;
    return typeof variant.featured_image === 'string' ? variant.featured_image : '';
  };

  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const colorCode = (value) => (value || '').split('-')[0].trim().toUpperCase();
  const sizeCode = (value) => {
    const millimeters = String(value || '').match(/\d+/)?.[0] || '';
    return { '70': '07', '95': '09', '110': '11', '125': '12', '140': '14', '210': '21' }[millimeters] || '';
  };
  const mediaFilename = (url) => decodeURIComponent(String(url || '').split('/').pop()?.split('?')[0] || '').toUpperCase();
  const isLureVariantImage = (url) => /FBLEP\d+-[A-Z0-9]+(?:_|\.|-)/.test(mediaFilename(url));
  const mediaCatalog = (root) => [...root.querySelectorAll('.benchmark-media img')]
    .map((image) => ({ url: image.currentSrc || image.src, filename: mediaFilename(image.currentSrc || image.src) }))
    .filter((item) => item.url);
  const inferredImageURL = (catalog, color, size = '') => {
    const code = colorCode(color);
    if (!code) return '';
    const colorPattern = new RegExp(`-${escapeRegExp(code)}(?:_|\\.|-)`);
    const candidates = catalog.filter((item) => colorPattern.test(item.filename));
    const wantedSize = sizeCode(size);
    return (candidates.find((item) => wantedSize && item.filename.includes(`FBLEP${wantedSize}-`)) || candidates[0])?.url || '';
  };

  const removeVariantImagesFromGallery = (root) => {
    root.querySelectorAll('.benchmark-media:not([data-variant-primary])').forEach((slide) => {
      const image = slide.querySelector('img');
      if (image && isLureVariantImage(image.currentSrc || image.src)) slide.remove();
    });

    const thumbList = root.querySelector('.media-thumbs');
    if (!thumbList) return;
    thumbList.querySelectorAll('.media-thumb:not([data-variant-primary-thumb])').forEach((thumb) => thumb.remove());
    [...root.querySelectorAll('.benchmark-media')].forEach((slide, index) => {
      slide.dataset.index = String(index);
      if (index === 0 || index > 3) return;
      const thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'media-thumb';
      thumb.dataset.thumb = String(index);
      const image = slide.querySelector('img');
      if (image) {
        const preview = image.cloneNode(false);
        preview.removeAttribute('srcset');
        thumb.append(preview);
      }
      const label = document.createElement('span');
      label.textContent = image?.alt || (slide.querySelector('video,iframe') ? 'VIDEO' : 'ON WATER');
      thumb.append(label);
      if (slide.querySelector('video,iframe')) {
        const icon = document.createElement('i');
        icon.textContent = '▶';
        thumb.append(icon);
      }
      thumbList.append(thumb);
    });
  };

  const cleanDescription = (root) => {
    const source = root.querySelector('.tfp-product-source');
    if (!source) return;
    const title = (root.dataset.productTitle || '').trim().toLowerCase();

    source.querySelectorAll('h1,h2,h3,h4,p,strong').forEach((node) => {
      const text = (node.textContent || '').trim().toLowerCase().replace(/\s+/g, ' ');
      if (title && (text === title || text.startsWith(`${title} –`) || text.startsWith(`${title} -`))) node.remove();
    });

    source.querySelectorAll('a[href*="P65Warnings" i],a[href*="p65warnings" i]').forEach((link) => link.closest('p,li')?.remove());
    source.querySelectorAll('p,li').forEach((node) => {
      if (/cancer and reproductive harm|p65warnings/i.test(node.textContent || '')) node.remove();
    });
  };

  const moveEmbeddedVideo = (root) => {
    const source = root.querySelector('.tfp-product-source');
    const embedded = source?.querySelector('iframe,video');
    const stage = root.querySelector('[data-gallery-stage]');
    const thumbList = root.querySelector('.media-thumbs');
    if (!embedded || !stage || !thumbList) return;

    embedded.remove();
    const index = stage.querySelectorAll('.benchmark-media').length;
    const item = document.createElement('div');
    item.className = 'benchmark-media tfp-benchmark-video';
    item.dataset.media = 'embedded-video';
    item.dataset.index = String(index);
    item.append(embedded);
    stage.append(item);

    const thumb = document.createElement('button');
    thumb.type = 'button';
    thumb.className = 'media-thumb tfp-video-thumb';
    thumb.dataset.thumb = String(index);
    thumb.innerHTML = '<span>VIDEO</span><i>▶</i>';
    thumbList.append(thumb);
  };

  const initGallery = (root) => {
    const slides = [...root.querySelectorAll('.benchmark-media')];
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    const progress = root.querySelector('[data-progress]');
    let active = Math.max(0, slides.findIndex((slide) => slide.classList.contains('selected')));

    const show = (index) => {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, position) => {
        slide.classList.toggle('selected', position === active);
        if (position !== active) slide.querySelector('video')?.pause();
      });
      thumbs.forEach((thumb) => thumb.classList.toggle('selected', Number(thumb.dataset.thumb) === active));
      if (progress) progress.style.width = `${((active + 1) / slides.length) * 100}%`;
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(Number(thumb.dataset.thumb))));
    root.querySelector('[data-prev]')?.addEventListener('click', () => show(active - 1));
    root.querySelector('[data-next]')?.addEventListener('click', () => show(active + 1));

    const stage = root.querySelector('[data-gallery-stage]');
    let touchStart = 0;
    stage?.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
    stage?.addEventListener('touchend', (event) => {
      const delta = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(delta) > 45) show(active + (delta < 0 ? 1 : -1));
    }, { passive: true });

    show(active);
    return { show };
  };

  const initVariants = (root, gallery, variants, catalog) => {
    const groups = [...root.querySelectorAll('[data-option]')];
    const currency = window.Shopify?.currency?.active || 'USD';
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);

    groups.forEach((group) => {
      const position = Number(group.dataset.option);
      group.querySelectorAll('[data-variant-swatch]').forEach((img) => {
        const button = img.closest('[data-value]');
        const variant = variants.find((item) => item.options?.[position] === button?.dataset.value && imageURL(item));
        const url = imageURL(variant) || inferredImageURL(catalog, button?.dataset.value);
        if (!url || !button) return;
        img.src = url;
        img.hidden = false;
        button.classList.add('has-image');
      });
    });

    const selectedValues = () => groups.map((group) => group.querySelector('button.selected')?.dataset.value || '');

    const updatePrimary = (variant) => {
      const url = imageURL(variant) || inferredImageURL(catalog, variant.options?.[0], variant.options?.[1]);
      if (!url) return;
      const images = [root.querySelector('[data-variant-primary] img'), root.querySelector('[data-variant-primary-thumb] img')];
      images.forEach((image) => {
        if (!image) return;
        image.src = url;
        image.srcset = '';
        image.alt = variant.title;
      });
      gallery.show(0);
    };

    // Size remains navigable across colors; colors depend on the selected size.
    const colorPosition = Number(groups.find((group) => group.classList.contains('color-options'))?.dataset.option ?? 0);
    const matches = (item, values) => item.options?.every((value, index) => value === values[index]);
    const choose = (variant) => {
      groups.forEach((group) => {
        const value = variant.options[Number(group.dataset.option)];
        group.querySelectorAll('[data-value]').forEach((button) => {
          const selected = button.dataset.value === value;
          button.classList.toggle('selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        const label = group.querySelector('[data-option-name]');
        if (label) label.textContent = value;
      });
    };

    const sync = (changedPosition) => {
      let chosen = selectedValues();
      let variant = variants.find((item) => matches(item, chosen));
      if (!variant) {
        const candidates = changedPosition === undefined ? variants : variants.filter((item) => item.options?.[changedPosition] === chosen[changedPosition]);
        variant = candidates.find((item) => item.available) || candidates[0];
      }
      if (variant) {
        choose(variant);
        chosen = variant.options;
      }

      groups.forEach((group) => {
        const position = Number(group.dataset.option);
        group.querySelectorAll('[data-value]').forEach((button) => {
          const candidates = variants.filter((item) => {
            if (item.options?.[position] !== button.dataset.value) return false;
            // Keep all published sizes reachable, including sizes in other colors.
            if (position === colorPosition) return true;
            return item.options.every((value, index) => index === position || value === chosen[index]);
          });
          const exists = candidates.length > 0;
          button.hidden = false;
          if (exists) button.style.removeProperty('display');
          else button.style.setProperty('display', 'none', 'important');
          button.disabled = !exists;
          button.classList.toggle('is-sold-out', exists && !candidates.some((item) => item.available));
        });
      });

      const idInput = root.querySelector('[data-variant-id]');
      const add = root.querySelector('[data-add]');
      const stickyAdd = root.querySelector('[data-sticky-add]');
      if (idInput) idInput.value = variant ? variant.id : '';
      if (add) add.disabled = !variant?.available;
      if (stickyAdd) stickyAdd.disabled = !variant?.available;
      root.querySelector('[data-add-label]').textContent = variant ? (variant.available ? 'ADD TO BAG' : 'SOLD OUT') : 'UNAVAILABLE';
      root.querySelector('[data-sticky-variant]').textContent = variant?.title || '';
      if (!variant) return;
      root.querySelector('[data-price]').textContent = money(variant.price);
      root.querySelector('[data-add-price]').textContent = money(variant.price);
      updatePrimary(variant);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(history.state, '', url);
    };

    groups.forEach((group) => {
      group.querySelectorAll('[data-value]').forEach((button) => button.addEventListener('click', () => {
        if (button.hidden || button.disabled) return;
        group.querySelectorAll('[data-value]').forEach((item) => item.classList.toggle('selected', item === button));
        sync(Number(group.dataset.option));
      }));
    });

    sync();
  };

  const positionMobileColors = (root) => {
    const colors = root.querySelector('.color-options');
    const slot = root.querySelector('[data-mobile-color-slot]');
    if (!colors || !slot) return;
    const marker = document.createComment('color-home');
    colors.before(marker);
    const place = () => {
      if (matchMedia('(max-width:600px)').matches) slot.append(colors);
      else marker.parentNode?.insertBefore(colors, marker.nextSibling);
    };
    place();
    addEventListener('resize', place);
  };

  const init = () => {
    const root = document.querySelector('[data-tfp-benchmark]');
    if (!root) return;
    document.body.classList.add('tfp-benchmark-page');
    document.querySelectorAll('.tfp-sticky-buy,.tfp-native-sticky').forEach((node) => node.remove());
    cleanDescription(root);
    moveEmbeddedVideo(root);
    const variants = parseJSON(root.querySelector('[data-variants]'));
    const catalog = mediaCatalog(root);
    removeVariantImagesFromGallery(root);
    const gallery = initGallery(root);
    initVariants(root, gallery, variants, catalog);
    positionMobileColors(root);
    root.querySelector('[data-sticky-add]')?.addEventListener('click', () => root.querySelector('[data-add]')?.click());
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
const mountMobileSizeSelectors=()=>{document.querySelectorAll('.tfp-benchmark').forEach(root=>{const slot=root.querySelector('[data-mobile-color-slot]');const original=root.querySelector('.buy-panel .option-group.size-options');if(!slot||!original||root.querySelector('.tfp-mobile-size-clone'))return;const originalSizeValues=original.querySelector('.size-values');if(originalSizeValues)Array.from(originalSizeValues.querySelectorAll('button[data-value]')).sort((a,b)=>parseFloat(a.dataset.value)-parseFloat(b.dataset.value)).forEach(button=>originalSizeValues.appendChild(button));const clone=original.cloneNode(true);clone.classList.add('tfp-mobile-size-clone');clone.removeAttribute('id');const sizeValues=clone.querySelector('.size-values');if(sizeValues)Array.from(sizeValues.querySelectorAll('button[data-value]')).sort((a,b)=>parseFloat(a.dataset.value)-parseFloat(b.dataset.value)).forEach(button=>sizeValues.appendChild(button));slot.insertAdjacentElement('afterend',clone);const variantData=root.querySelector('script[data-variants]');let variantList=[];try{variantList=JSON.parse(variantData?.textContent||'[]')}catch(error){}const sync=()=>{const selectedColor=root.querySelector('.mobile-color-slot .color-options button[aria-pressed="true"],.mobile-color-slot .color-options button.is-selected')?.dataset.value;clone.querySelectorAll('button[data-value]').forEach(button=>{const source=Array.from(original.querySelectorAll('button[data-value]')).find(item=>item.dataset.value===button.dataset.value);if(!source)return;button.className=source.className;const available=source&&!source.disabled&&!source.hidden;button.disabled=!available;button.hidden=false;button.style.setProperty('display',available?'inline-flex':'none','important');button.classList.toggle('is-sold-out',!available);button.setAttribute('aria-pressed',source.getAttribute('aria-pressed')||'false')})};const label=clone.querySelector('[data-option-name]');const selected=clone.querySelector('button.selected,button.is-selected,button[aria-pressed="true"]');if(label&&selected)label.textContent=selected.dataset.value;clone.addEventListener('click',event=>{const button=event.target.closest('button[data-value]');if(!button)return;const source=Array.from(original.querySelectorAll('button[data-value]')).find(item=>item.dataset.value===button.dataset.value);if(source&&!source.disabled){source.click();setTimeout(()=>{sync();if(label)label.textContent=button.dataset.value},0)}});root.addEventListener('click',event=>{if(event.target.closest('.color-options button,.buy-panel .size-options button'))setTimeout(sync,0)});new MutationObserver(sync).observe(original,{subtree:true,attributes:true,attributeFilter:['class','aria-pressed','disabled','hidden']});sync()});if(!document.getElementById('tfp-mobile-size-style')){const style=document.createElement('style');style.id='tfp-mobile-size-style';style.textContent='.tfp-mobile-size-clone{display:none}@media(max-width:600px){.tfp-benchmark .buy-panel .option-group.size-options:not(.tfp-mobile-size-clone){display:none}.tfp-benchmark .gallery>.tfp-mobile-size-clone{display:block;margin:0 0 12px}.tfp-benchmark .gallery>.tfp-mobile-size-clone button:not(:disabled){display:inline-flex!important}}';document.head.appendChild(style)}};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mountMobileSizeSelectors);else mountMobileSizeSelectors();
const syncMobileSizeLabels=()=>document.querySelectorAll('.tfp-mobile-size-clone').forEach(clone=>{const selected=clone.querySelector('button[aria-pressed="true"],button.selected,button.is-selected');const label=clone.querySelector('[data-option-name]');if(label&&selected)label.textContent=selected.dataset.value});document.addEventListener('click',event=>{if(event.target.closest('.color-options button,.tfp-mobile-size-clone button'))setTimeout(syncMobileSizeLabels,0)});syncMobileSizeLabels();
})();
